import type { AdminProfile } from '../api/types';

const KEY = 'rewards-admin-session';

export interface Session {
  token: string;
  admin: AdminProfile;
  /** Epoch em ms. */
  expiresAt: number;
}

/**
 * `sessionStorage`, não `localStorage`: a sessão de quem enxerga todas as
 * plataformas termina quando a aba fecha. O acesso pode lançar (navegação
 * privada, armazenamento bloqueado) — nesse caso a sessão só vive em memória.
 */
export function loadSession(now: number = Date.now()): Session | null {
  try {
    const raw = window.sessionStorage.getItem(KEY);

    if (raw === null) {
      return null;
    }

    const session = JSON.parse(raw) as Session;

    return session.expiresAt > now ? session : null;
  } catch {
    return null;
  }
}

export function saveSession(session: Session): void {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(session));
  } catch {
    // Sem armazenamento: a sessão segue em memória até recarregar a página.
  }
}

export function clearSession(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // Nada a limpar.
  }
}
